import {useChangeSubscription} from '@/api/payments';
import {getGqlErrorMessage, isAccessRestrictionError} from '@/api/request';
import {Button, ButtonGroup} from '@/components/Button';
import toast from '@/components/HotToast';
import {Modal} from '@/components/Modal';
import {Typography} from '@/components/Typography';
import {BillingStatusType} from '@/enums';
import {PaddingBox} from '@/styled-components';
import {palette} from '@/styles';

interface IProps {
  billingInfo?: any;
  onClose?(): void;
  onComplete?(record: any): void;
}

export const ResumePlanModal = ({billingInfo, onClose, onComplete}: IProps) => {
  const {mutate, isPending} = useChangeSubscription();

  const resume = () => {
    mutate(
      {
        state: BillingStatusType.Live,
      },
      {
        onSuccess: (data) => {
          if (data.result) {
            onComplete?.(billingInfo);
          } else {
            toast.error('요청이 실패했습니다. 잠시 후 다시 시도해주세요.');
          }
        },
        onError: (error) => {
          // 이용 제한은 공통 에러 핸들러가 안내 모달을 띄운다.
          if (!isAccessRestrictionError(error)) {
            toast.error(getGqlErrorMessage(error));
          }
        },
      }
    );
  };

  return (
    <Modal title="구독 해지 신청 취소" width={328} onClose={onClose}>
      <PaddingBox spacing={24}>
        <Typography variant="medium14" color={palette.gray600}>
          구독 해지 신청을 취소하시겠어요?
          <br />
          구독 해지 신청 이전 상태로 복구됩니다
        </Typography>
        <PaddingBox top={24}>
          <ButtonGroup flex={1} spacing={2}>
            <Button
              size="medium"
              color="white"
              variant="fill"
              fullWidth
              onClick={onClose}
            >
              아니오
            </Button>
            <Button
              size="medium"
              color="secondary"
              variant="fill"
              fullWidth
              disabled={isPending}
              onClick={resume}
            >
              {isPending ? '해지 신청 취소 중...' : '네'}
            </Button>
          </ButtonGroup>
        </PaddingBox>
      </PaddingBox>
    </Modal>
  );
};
